const URL = `//apigate.${window.Acme.getDomain()}/d/platform/fundholo/getData/`;
// const URL = process.env.VUE_APP_MOCK == 'true' ? '//yapi.10jqka.com.cn/mock/105/screen9' : '/macrod/screen/getSeventhScreenData';

class blockAPI {
    //宏观流动性数据获取
    gethongguanldx() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${URL}firstcolumn`,
                    type: 'GET',
                    success: function(data) {
                        resolve(data);
                    }
                })
            });
        }
        //第二行数据获取
    getsecondColumnChart() {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${URL}secondcolumn`,
                    type: 'GET',
                    success: function(data) {
                        resolve(data);
                    }
                })
            });
        }
        //中观数据获取
        getthirdcolumn() {            
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${URL}thirdcolumn`,
                    type: 'GET',
                    success: function(data) {
                        resolve(data);
                    }
                })
            });            
        }
        //第四行数据获取
    getFourthcolumn() {
            // return axios.get(`xxxx`);
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: `${URL}fourthcolumn`,
                    type: 'GET',
                    success: function(data) {
                        resolve(data);
                    }
                })
            });
        }
        //第五行数据获取
    getFifthcolumn() {
        // return axios.get(`xxxx`);
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}fifthcolumn`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    getSZSeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}sz_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    getCYSeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}cy_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 沪深成交金额
    getTradingMoneySeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}trading_money_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    getDR007Series(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}DR007_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 第4行 1
    getQFIIRQFIIseries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}QFII_RQFII_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 第4行 1 公募基金
    getFundIssuanceMoneySeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}fund_issuance_money_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 第4行 2 增持资金
    getIncreaseMoneySeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}increase_money_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 第4行 2 回购资金
    getBackBuyMoneySeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}back_buy_money_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 5 1 减持资金
    getReductionMoneySeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}reduction_money_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

    // 5 1 配股资金
    getAllotmentMoneySeries(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `${URL}allotment_money_series`,
                type: 'GET',
                success: function(data) {
                    resolve(data);
                }
            })
        });
    }

}

export default new blockAPI();
